import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { useCallback, useId, useMemo } from 'react';
const LEXICAL_EDITOR_THEME = {
    link: 'text-super-primary hover:underline',
    text: {
        strikethrough: 'line-through',
    },
};
/** Builds the Lexical initial config for a composer editor instance. */
export const useLexicalInitialConfig = ({ nodes = EMPTY_ARRAY, editable = true, } = {}) => {
    const namespace = useId();
    const onError = useCallback((error) => {
        // Catch any errors that occur during Lexical updates and log them
        // or throw them as needed. If you don't throw them, Lexical will
        // try to recover gracefully without losing user data.
        logger.error(error);
    }, []);
    return useMemo(() => ({
        namespace,
        onError,
        nodes,
        theme: LEXICAL_EDITOR_THEME,
        editable,
    }), [namespace, onError, nodes, editable]);
};
//# sourceMappingURL=useLexicalInitialConfig.js.map